import * as React from "react";

import { nullElement } from "../../TypingUtils";

interface BodyProps {
    children?: JSX.Element;
}

export function Body(props: BodyProps): JSX.Element | null {
    return props.children ? <section>{props.children}</section> : nullElement;
}
